<!--【首页头部区域】：包含登录|注册-->
<template>
  <div class="main-header">
    <user-login ref="userLoginDialog"></user-login>
    <user-register ref="userRegisterDialog"></user-register>
    <user-info ref="userInfoDialog"/>
    <user-password ref="passwordDialog"/>
    <sui-user-collect type="收藏" path="categoryDetails" ref="collectDialog"/>
    <div class="header">
      <div class="header-content">
        <div class="header-banner">
          <el-menu router :default-active="$route.path" style="width: 100%;height: 60px" class="el-menu-demo" mode="horizontal" text-color="#fff" active-text-color="#E8F4FF">
            <router-link :to="{ path: '/front/home' }" class="float-l pointer">
              <el-avatar class="header-logo" src="/static/images/front/logo/logo.jpg"></el-avatar>
              <span class="projectName">{{projectName}}</span>
            </router-link>
            <el-menu-item index="/front/course">毕设指导</el-menu-item>
            <el-menu-item index="/front/software">软件中心</el-menu-item>
            <el-menu-item index="/front/search">答辩百科</el-menu-item>
            <el-menu-item v-if="!isMobile()" index="/front/works">作品展示</el-menu-item>
            <el-menu-item index="/front/about">联系我们</el-menu-item>
          </el-menu>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {mapActions} from "vuex";
  export default {
    name: "home-header",
    data(){
      return {
        //路由的key
        rootKey: new Date().getTime(),
      }
    },
    computed:{
      userInfo(){
        return this.$store.getters.userInfo;
      },
      hasLogin(){
        return this.$store.getters.hasLogin;
      },
      projectName(){
        return this.$store.getters.config.projectName;
      }
    },
    mounted() {
    },
    methods: {
      ...mapActions(['commitFrontLoginOut']),
      loginOut(){
        const that = this;
        that.showConfirm('确认退出吗?',function (){
          that.commitFrontLoginOut().then(res=>{
            if(res.isOk){
              that.$router.push("/front/home");
              that.showToast("退出成功");
            }
          })
        })
      },
      userLogin() {
        this.$refs.userLoginDialog.open({title:'账号登录'});
      },
      userRegister() {
        this.$refs.userRegisterDialog.open({title:'用户注册'});
      },
      updateUserInfo() {
        this.$refs.userInfoDialog.open({title:'用户信息'});
      },
      updatePassword() {
        this.$refs.passwordDialog.open({title:'修改密码'});
      },
      userCollect() {
        this.$refs.collectDialog.open({title:'我的收藏'});
      },
    }
  }
</script>
<style scoped lang="scss" scoped>
  @import '../../../assets/styles/theme';
  .header {
    z-index: 1000;
    color:$theme-front-font-color;
    background: $theme-front-color;
    position: fixed;
    overflow-x: auto;
    /*overflow-y: hidden;*/
    width: 100%
  }
  .el-menu-item {
    background: $theme-front-color !important;
  }
  .el-menu-demo {
    background-color: $theme-front-color !important;;
  }
  .projectName {
    width: 200px;
    vertical-align: middle;
    font-size: 20px;
    font-weight: bold;
    font-family: "Helvetica Neue"
  }

  .el-dropdown-link {
    color: whitesmoke;
    font-size: 16px;
  }
  .el-icon-arrow-down {
    font-size: 16px;
  }

  .tab {
    line-height: 65px;
    font-size: 15px;
    float: left;
    margin-left: 30px;
  }

  .tab:hover {
    color:whitesmoke;
  }

  .loginName {
    font-weight: bold;
    font-size: medium
  }

  .middle {
    vertical-align: middle
  }

  .header-content {
    line-height: 60px;
    width: 620px;
    margin-left: 20px;
    /*margin: 0 auto;*/
  }

  .header-logo {
    border: solid 2px white;
    vertical-align: middle;
    width: 45px;
    height: 45px;
  }

  .header-banner {
    vertical-align: middle;
  }

  .register:hover, .login:hover{
    color:whitesmoke;
  }
  .login,.register{
    margin-left: 10px;
    font-size: 12px;
  }
  .el-menu.el-menu--horizontal{
    border-bottom: solid 1px #2F77BF;
  }
</style>




// WEBPACK FOOTER //
// src/pages/front/index/index-header.vue